const STORAGE_KEY = "kaer.runningWorkerCsvImports";

export interface StoredWorkerCsvImport {
  taskId: string;
  startedAt: string;
}

type StoredWorkerCsvImports = Record<string, StoredWorkerCsvImport>;

const readStoredImports = (): StoredWorkerCsvImports => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeStoredImports = (imports: StoredWorkerCsvImports) => {
  try {
    if (Object.keys(imports).length === 0) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(imports));
  } catch {
    // storage unavailable (private mode, quota): tracking simply does not survive a reload
  }
};

export const getRunningWorkerCsvImport = (
  companySubjectId: string
): StoredWorkerCsvImport | null =>
  readStoredImports()[companySubjectId] ?? null;

export const rememberRunningWorkerCsvImport = (
  companySubjectId: string,
  runningImport: StoredWorkerCsvImport
) => {
  writeStoredImports({
    ...readStoredImports(),
    [companySubjectId]: runningImport,
  });
};

export const forgetRunningWorkerCsvImport = (companySubjectId: string) => {
  const remaining = { ...readStoredImports() };
  delete remaining[companySubjectId];
  writeStoredImports(remaining);
};
